import React, { Component, CSSProperties } from 'react'
import { connect } from 'react-redux'
import { debounce } from 'lodash'
import trans from "trans"

import {
    css,
    Grid,
    GridCell,
    Theme,
} from "@bdfx/mergado-ui-kit"

import { updateInputValue } from "app/reducers/form"

import { setHelper } from "actions";
import store from "store";

import Shape, {
    BADGE_TYPE, BEZIER_TYPE, BITMAP_TYPE, CIRCLE_TEXT_TYPE, CURVED_TEXT_TYPE, CUSTOM_SET_TYPE, DASHED_FRAME_TYPE,
    DYNAMIC_TEXT_TYPE, IMAGE_FROM_ELEMENTS_TYPE, LINE_TYPE, SOURCE_IMAGE_TYPE, TEXT_INSIDE_SHAPE_TYPE, TEXT_TYPE,
    TRIANGLE2_TYPE, TEXT_WITH_ELEMENTS_TYPE, TRIANGLE1_TYPE, CIRCLE_TYPE, RECTANGLE_TYPE, POLYGON_TYPE, FRAME_TYPE,
    ELLIPSE_TYPE,
    IMAGE_TYPE,
    NONE_TYPE,
    RECTANGLE_EACH_LINE_TYPE,
    BRUSH_TYPE,
    EXTERNAL_IMAGE_SOURCE_TYPE,
    RATING_TYPE,
    TEXT_SHAPE_TYPES,
    RESIZE_TYPES_TO_CHANGE_FONTSIZE
} from "shape-entities/types/shape";

import { URL } from "app/config/api-config";
import {
    ACTIVE_VIEW_EDIT_QUERIES, ACTIVE_VIEW_EDIT_SHAPE, ACTIVE_VIEW_EDIT_SOURCE_IMAGE, ACTIVE_VIEW_NEW_SHAPE,
    ACTIVE_VIEW_SHAPE_SELECTION, ActiveViewType
} from "../containers/Editor";
import { Query, SettingsFormType, Size, SizeType, Template } from "app/types/model-types";
import { EditModeType, GuidesType, HelperType, ReduxList } from "app/types/app-types"
import CircleSvg from "shape-entities/components/circle-svg";
import RectangleSvg from "shape-entities/components/rectangle-svg";
import FrameSvg from "shape-entities/components/frame-svg";
import TriangleSvg from "shape-entities/components/triangle-svg";
import DashedFrameSvg from "shape-entities/components/dashed-frame-svg";
import BitmapSvg from "shape-entities/components/bitmap-svg";
import TextSvg from "shape-entities/components/text-svg";
import DynamicTextSvg from "shape-entities/components/dynamic-text-svg";
import TextWithElementsSvg from "shape-entities/components/text-with-elements-svg";
import CircleTextSvg from "shape-entities/components/circle-text-svg";
import PathSvg from "shape-entities/components/path-svg";
import PolygonAndPolylineSvg from "shape-entities/components/polygon-and-polyline-svg";
import ImageFromElementsSvg from 'shape-entities/components/image-from-elements-svg';
import SourceImageSvg from 'shape-entities/components/source-image-svg';
import { ClipMaskObject } from 'shape-edit/forms/edit-clip-mask-modal';
import MoveablePoints from './moveable-points';
import { selectFormValues } from 'app/reducers/form';
import { GradientFillUrl } from 'shape-edit/forms/fields';
import BrushSvg from 'shape-entities/components/brush-svg'
import {
    DEFAULT_FONT_WEIGHT, LETTER_CASE_FIRST_LETTER_TO_LOWER, LETTER_CASE_FIRST_LETTER_TO_UPPER,
    LETTER_CASE_TO_LOWER, LETTER_CASE_TO_UPPER, LETTER_CASE_WORDS_FIRST_TO_UPPER, manualBreakLine, OVERFLOW_FONTSIZE,
    OVERFLOW_KEEP_AS_IS,
    OVERFLOW_LAYERSIZE, TEXT_HORIZONTAL_ALIGN_CENTER, TEXT_ORIENTATION_VERTICAL, TEXT_VERTICAL_ALIGN_MIDDLE
} from '../../shape-entities/render-text';
import { DEFAULT_LINE_CAP, DEFAULT_LINE_JOIN, getShapeSize, getTemplateSize, LINE_CAP_CONSTS, LINE_JOIN_CONSTS } from 'shape-edit/forms/helpers'
import ShapeType from 'shape-entities/types/shape';
import { isPointShapeType, shouldAspectRatio } from 'shape-entities/defaults'
import { LevelsModeType } from './save-template-form'
import RatingSvg from 'shape-entities/components/rating-svg'
import { ResizeElementType } from 'shape-entities/components/draggable-rectangle'
import { DeltaPositionsType } from 'template-edit/containers/image-preview'
import { recalcClipMaskSizeAndPositions, scaleBrushStrokes, scalePoints } from 'shape-edit/forms/delta-positions-helper'
import { svgRescale } from 'app/helpers/api'
import { AxiosResponse } from 'axios'
import { getStringWidthAndHeight, WordLengthType } from 'svg-text-utils/SVGTextWrapped'
import { hasPangoMarkup, mapPangoChars, splitPangoChars, splitPangoWords } from 'svg-text-utils/pango-markup'
import { isJson } from 'app/helpers/other'
import RatingShape from 'shape-entities/types/Rating'

export type ContentType = { text: any, title: string }

const { min, max, abs, sin, cos, PI, round, atan2, ceil } = Math

interface Props {
    helper: HelperType
    settingsForm: SettingsFormType
    setHelper: typeof setHelper
    updateInputValue: typeof updateInputValue
}

class Helper extends Component<Props> {
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
        if (this.props.helper?.isMaximized && !prevProps.helper?.isMaximized && this.props.settingsForm.disable_helper) {
            this.minimize(false)
        }
    }

    maximize = () => {
        const { helper } = this.props
        this.props.setHelper({ ...helper, isMaximized: true })
    }

    minimize = (updateClosedAt: boolean) => {
        const { helper } = this.props
        this.props.setHelper({ ...helper, isMaximized: false, closedAt: updateClosedAt ? Date.now() : helper.closedAt })
    }

    close = () => {
        this.minimize(true)
    }

    render() {
        const { helper, settingsForm } = this.props

        if (settingsForm.disable_helper) {
            return <span />
        }

        const helperNoTitle = !helper.text ? trans('need_help_title') : ''
        const helperNoText = !helper.title ? trans('need_help_text') : ''
        return (
            <React.Fragment>
                <StyledHelper isMaximized={false} className={helper.isMaximized ? "active" : ""}>
                    <StyledContent id='helper-content' className={`${helper.className} minimized`} onClick={() => helper.isMaximized ? this.minimize(false) : this.maximize()}>
                        <div className={'helper-image'}>
                            <img className={'light-bulb'} src={`${URL.publicPath}img/icons/helper/lightbulb-helper.svg`} title={trans('helper')} />
                        </div>
                        {helper.text ? <Badge>1</Badge> : null}
                    </StyledContent>
                </StyledHelper>
                {helper.isMaximized ?
                    <StyledHelper style={{ left: "48px", bottom: "40px" }} id={'helper-wrapper'} className={helper.isMaximized ? "maximized" : ""} isMaximized={helper.isMaximized}>
                        {helper.isMaximized &&
                            <Grid className={'g-top'}>
                                <GridCell>
                                    <div className={'helper-title'}>
                                        {helper.title ? helper.title : helperNoTitle}
                                    </div>

                                </GridCell>
                                <GridCell className="close-button">
                                    <div onClick={() => this.close()}>
                                        <span color="nocolor" className="muk-button muk-toast__button">×</span>
                                    </div>
                                </GridCell>
                            </Grid>
                        }

                        <StyledContent id='helper-content' className={`${helper.className} ${helper.isMaximized ? 'maximized' : 'minimized'}`}>
                            {helper.isMaximized &&
                                <div className={'helper-text'}>
                                    {helper.text ? helper.text : helperNoText}
                                </div>
                            }
                        </StyledContent>
                    </StyledHelper>

                    : null}

            </React.Fragment>
        )
    }
}

const Badge = css("div")({
    display: "inline-block",
    width: "18px",
    height: "18px",
    background: "#DE4149",
    fontWeight: "bold",
    color: "#fff",
    borderRadius: "9999em",
    position: "absolute",
    fontSize: "11px",
    lineHeight: "20px",
    top: "-5px",
    right: "-5px",
})

const StyledHelper = css('div')({
    '@media screen and (max-width: 800px), screen and (max-height: 250px)': {
        display: 'none',
        visibility: 'hidden',
    },
    position: 'fixed',
    zIndex: 999,
    boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    webkitBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    mozBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    borderRadius: '5px',
    background: '#e0bf00',
    bottom: '6px',
    left: '15px',
    padding: '0 1px',
    textAlign: "center",
    "&.active": {
        background: "#2a8a05",
    },
    "&.maximized": {
        pointerEvents: 'auto',
        background: '#FFFFFD',
        color: "#333",
        boxShadow: '1px 0 15px 4px rgb(0 0 0 / 15%)',
        borderRadius: '5px 5px 5px 0',
    },
    ' .close-button': {
        textAlign: 'right',
        webkitAlignSelf: 'start',
        alignSelf: 'start',
        marginTop: "-5px",

        cursor: 'pointer',
        ' .muk-button': {
            fontSize: '18px',
            fontWeight: 'normal',
            color: '#272727',
        },
    },
    ' .maximized': {
        width: '300px',
        height: 'auto',
        transition: 'height 1s',
    },
    ' .minimized': {
        pointerEvents: 'auto',
        width: '36px',
        height: '36px',
        transition: 'width .5s ease-in-out, height .7s',
        transitionDelay: '0.1s',
    },
    ' img.light-bulb': {
        width: '26px',
        height: '32px',
    },
    ' .g-top': {
        gridTemplateColumns: 'auto min-content',
        paddingBottom: '8px',
    },
    ' .muk-gridcell': {
        alignSelf: 'center',
    },
    ' a.mail-link': {
        color: Theme.steelblue,
        textDecoration: 'none',
    },
    ' .helper-title': {
        fontWeight: 'bold',
        borderBottom: "1px solid #eee",
        textAlign: "left",
        fontSize: "13px",
        marginRight: "-22px",
        marginLeft: "-12px",
        paddingBottom: "5px",
        paddingLeft: "10px",
    },
    ' .helper-image': {
        textAlign: 'center',
        ' .m-image path': {
            fill: '#3a3a3a !important',
        },
    },
}, props => {
    return {
        padding: props.isMaximized ? '10px 12px' : '5px',
        cursor: props.isMaximized ? 'default' : 'pointer',
    };
})

const StyledContent = css('div')({
    ' .helper-text': {
        color: '#364B7B',
        width: '100%',
        textAlign: "left",
        height: '100%',
        borderRadius: '8px',
        borderTopLeftRadius: 0,
        padding: '3px',
        fontSize: "13px",
        lineHeight: "18px",
    },
    ' .check-box': {
        paddingTop: '10px',
        color: '#fff',
        margin: 0,
    },
    ' .muk-form-group': {
        marginBottom: 0,
    },
    ' .m-label-wrapper': {
        fontSize: '12px',
    },
    ' .muk-form-label': {
        height: '18px',
    },
    ' ul, ol': {
        padding: '0',
        margin: 0,
        listStyle: 'none',
        textAlign: "left",
        fontSize: "13px",
        "li": {
            background: `url(${URL.publicPath}img/icons/helper/lightbulb.svg) left top no-repeat`,
            paddingLeft: "20px",
            backgroundSize: "15px",
        },

    },
    ' .lightbulb-marker': {
        backgroundImage: `url(${URL.publicPath}img/icons/helper/lightbulb.svg)`,
    },
    ' .exclamation-marker': {
        backgroundImage: `url(${URL.publicPath}img/icons/helper/exclamation.svg)`,
    },
    ' .info-marker': {
        backgroundImage: `url(${URL.publicPath}img/icons/helper/info-circle.svg)`,
    },
    ' .right-arrow-marker': {
        backgroundImage: `url(${URL.publicPath}img/icons/helper/arrow-circle-o-right.svg)`,
    },
    ' .framed': {
        border: '1px solid ' + Theme.grey,
        borderRadius: '3px',
        padding: '0 3px',
        margin: '0 5px 0 0',
    },
    ' .quote': {
        margin: '8px 0',
    },
    ' .muk-icon': {
        maxWidth: '18px',
        maxHeight: '18px',
        marginBottom: '-2px',
    },
    ' .filter-blue': {
        filter: 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)',
    },
    ' p': {
        margin: 0,
        verticalAlign: 'middle',
        lineHeight: '20px',
    }
})

function mapStateToProps(state) {
    return {
        helper: state.helper,
        settingsForm: selectFormValues(state, 'settingsForm'),
    }
}

export default connect(mapStateToProps, {
    updateInputValue,
    setHelper,
})(Helper)

export function setHelperText(content: ContentType | null): void {
    const state: any = store.getState()
    const helper: HelperType = state.helper
    if (content) {
        store.dispatch(setHelper({ ...helper, title: content.title, text: content.text }))
    }
}

export function getHelperContentByActiveShape(activeShape: Shape): ContentType {
    if (!activeShape) {
        return null;
    }
    switch (activeShape.type) {
        case RECTANGLE_TYPE:
        case CIRCLE_TYPE:
        case TRIANGLE1_TYPE:
        case TEXT_TYPE:
        case DYNAMIC_TEXT_TYPE:
        case TEXT_WITH_ELEMENTS_TYPE:
            return {
                text: trans("helper_tips"),
                title: "TIP",
            }
        case BEZIER_TYPE:
            if (!activeShape.points) {
                return { text: trans('bezier_no_points'), title: trans('bezier') }
            } else if (Array.isArray(activeShape.points) && activeShape.points.length === 1) {
                return { text: trans('bezier_add_points'), title: trans('bezier') }
            }
            return {
                text: <div>
                    <p>{trans('bezier_add_points')}</p>
                    <p>{trans('bezier_unselect')}</p>
                </div>, title: trans('bezier')
            }
        default:
            return null
    }
}

export function getHelperContentByActiveView(activeView: ActiveViewType, storeState: any): ContentType {
    const templateForm: Template = selectFormValues(storeState,'templateForm')
    const queries: ReduxList<Query> = storeState.queries
    switch (activeView) {
        case ACTIVE_VIEW_EDIT_SOURCE_IMAGE:
            if (templateForm.size_id) {
                return { text: trans('helper_format_selected'), title: trans('format') }
            }
            return { text: trans('helper_no_format'), title: trans('format') }
        case ACTIVE_VIEW_EDIT_QUERIES:
            return {
                text: <div>
                    {templateForm.queries?.length > 0 &&
                        queries && queries.data && Array.isArray(queries.data) && queries.data.filter(query => templateForm.queries.includes(query.id) && query.product_count === 0).length > 0 &&
                        trans('helper_zero_products_query')
                    }
                    {templateForm.queries?.length === 0 &&
                        trans('helper_no_queries')
                    }
                    {templateForm.queries?.length === 1 &&
                        trans('helper_one_query')
                    }
                    {templateForm.queries?.length > 0 &&
                        trans('helper_at_least_one_query')
                    }
                </div>, title: trans('queries')
            }
        case ACTIVE_VIEW_SHAPE_SELECTION:
            const shapesCount = templateForm.shapes ? Object.getOwnPropertyNames(templateForm.shapes).filter(v => v !== 'sourceImage').length : 0
            if (shapesCount === 0) {
                return { text: trans('helper_no_layer'), title: trans('layers') }
            } else if (shapesCount === 1) {
                return { text: trans('helper_at_least_one_layer', { ArrowVIcon: '<img src="' + URL.publicPath + '/img/icons/helper/arrows-v.svg" class="muk-icon"/>' }), title: trans('layers') }
            } else if (shapesCount > 1) {
                return { text: trans('helper_two_more_layers', { GroupIcon: '<img src="' + URL.publicPath + '/img/icons/helper/object-group.svg" class="muk-icon"/>', MagnetIcon: '<img src="' + URL.publicPath + '/img/icons/helper/magnet.svg" class="muk-icon"/>' }), title: trans('layers') }
            }
            return { text: null, title: null }
        case ACTIVE_VIEW_NEW_SHAPE:
        case ACTIVE_VIEW_EDIT_SHAPE:
        default:
            return { text: null, title: null }
    }
}

export const alternativeTemplateUsers = [8980, 15504, 39898] //dev only
export const testUsers = [8980]
export const labUsers = [8980, 4749, 27494, 39898]
export const allowSuperadminForUsers = [8980, 3497, 128, 3538, 4749, 15504, 27494, 39898]
export const allowObjectToImageRatioForUsers = [8980, 4749, 128, 15504, 39898, 3538, 27494, 39898]

export const textCursorPath15x15 = "M 4.6 0.7 C 4.4 0.7 4.2 0.9 4.2 1.2 C 4.2 1.4 4.4 1.7 4.6 1.7C 5.3 1.7 5.8 1.9 6 2.2 C 6.3 2.6 6.5 3 6.5 3.7 C 6.5 11.3 6.3 11.8 6 12.1C 5.8 12.4 5.3 12.7 4.6 12.7 C 4.4 12.7 4.2 12.9 4.2 13.2C 4.2 13.4 4.4 13.7 4.6 13.7 C 5.4 13.7 6.1 13.4 6.5 12.9C 6.7 12.7 6.8 12.6 6.9 12.4 C 7 12.6 7.1 12.7 7.2 12.9C 7.6 13.4 8.3 13.7 9.1 13.7 C 9.3 13.7 9.5 13.4 9.5 13.2C 9.5 12.9 9.3 12.7 9.1 12.7 C 8.4 12.7 8 12.4 7.7 12.1C 7.4 11.8 7.2 11.3 7.2 10.7C 7.2 3 7.4 2.6 7.7 2.2 C 8 1.9 8.4 1.7 9.1 1.7 C 9.3 1.7 9.5 1.4 9.5 1.2 C 9.5 0.9 9.3 0.7 9.1 0.7 C 8.3 0.7 7.6 0.9 7.2 1.5 C 7.1 1.6 7 1.8 6.9 1.9C 6.8 1.8 6.7 1.6 6.5 1.5 C 6.1 0.9 5.4 0.7 4.6 0.7 Z"

const RATING_WIDTH_COEF = 11.8
const RATING_HEIGHT_COEF = 1.5

export function getRatingShapeFontSize(shape: RatingShape, newWidth: number, newHeight: number): number
{
    const textPadding = shape.text_padding ? shape.text_padding : 0
    const halfStrokeWidth = shape.stroke_width ? .5*shape.stroke_width : 0

    const deltaWidth = shape.width - newWidth
    const deltaHeight = shape.height - newHeight

    if (abs(deltaWidth) > abs(deltaHeight)) {
        const fontSizeByWidth = round((newWidth - 2 * textPadding - halfStrokeWidth) / RATING_WIDTH_COEF)
        return fontSizeByWidth
    } else {
        const fontSizeByHeight = round((newHeight - 2 * textPadding - halfStrokeWidth) / RATING_HEIGHT_COEF)
        return fontSizeByHeight
    }
}

export function getRatingShapeSize(fontSize: number, shapeTextPadding: number|null, shapeStrokeWidth: number|null): SizeType
{
    const textPadding = shapeTextPadding ? shapeTextPadding : 0
    const halfStrokeWidth = shapeStrokeWidth ? .5 * shapeStrokeWidth : 0

    //console.debug(`debug getRatingShapeSize: padding ${textPadding}, fontSize: ${fontSize}, new size: ${round((RATING_WIDTH_COEF * fontSize) + 2 * textPadding + halfStrokeWidth)}x${round((RATING_HEIGHT_COEF * fontSize) + 2 * textPadding + halfStrokeWidth)}`)

    return {
        width: round((RATING_WIDTH_COEF * fontSize) + 2 * textPadding + halfStrokeWidth),
        height: round((RATING_HEIGHT_COEF * fontSize) + 2 * textPadding + halfStrokeWidth),
    }
}

export function getShapeByType(originalShape, size: SizeType, isDraggable: boolean, activeShapeId: string, editMode: EditModeType, updateShape: Function = undefined, levels: string[] = null, levelsMode: LevelsModeType = null, deltaWidth: number = 0, deltaHeight: number = 0): React.JSX.Element {
    const shape = {
        ...originalShape,
        width: abs(originalShape.width + deltaWidth),
        height: abs(originalShape.height + deltaHeight),
    }

    switch (shape.type) {
        case CIRCLE_TYPE:
        case ELLIPSE_TYPE:
            return <CircleSvg data={shape} activeShapeId={activeShapeId} updateShape={updateShape} editMode={editMode} />
        case RECTANGLE_TYPE:
            return <RectangleSvg data={shape} activeShapeId={activeShapeId} updateShape={updateShape} editMode={editMode} />
        case RATING_TYPE:
            return <RatingSvg shape={shape} updateShape={updateShape} />
        case TRIANGLE1_TYPE:
            return <TriangleSvg data={shape} activeShapeId={activeShapeId} turnUpsideDown={false} updateShape={updateShape} editMode={editMode} />
        case TRIANGLE2_TYPE:
            return <TriangleSvg data={shape} activeShapeId={activeShapeId} turnUpsideDown={true} updateShape={updateShape} editMode={editMode} />
        case FRAME_TYPE:
            return <FrameSvg data={shape} size={size} />
        case BRUSH_TYPE:
            return <BrushSvg data={shape} size={size} />
        case DASHED_FRAME_TYPE:
            return <DashedFrameSvg data={shape} size={size} />
        case BITMAP_TYPE:
        case BADGE_TYPE:
        case CUSTOM_SET_TYPE:
        case EXTERNAL_IMAGE_SOURCE_TYPE:
            return <BitmapSvg data={shape} />
        case TEXT_TYPE:
            return <TextSvg data={shape} activeShapeId={activeShapeId} updateShape={updateShape} editMode={editMode} />
        case DYNAMIC_TEXT_TYPE:
            return <DynamicTextSvg data={shape} activeShapeId={activeShapeId} updateShape={updateShape} editMode={editMode} />
        case IMAGE_FROM_ELEMENTS_TYPE:
            return <ImageFromElementsSvg data={shape} />
        case TEXT_WITH_ELEMENTS_TYPE:
            return <TextWithElementsSvg data={shape} activeShapeId={activeShapeId} editMode={editMode} />
        case CIRCLE_TEXT_TYPE:
            return <CircleTextSvg data={shape} />
        case TEXT_INSIDE_SHAPE_TYPE:
        case CURVED_TEXT_TYPE:
        case BEZIER_TYPE:
            return <PathSvg data={shape} size={size} isDraggable={isDraggable} editMode={editMode} />
        case LINE_TYPE:
        case POLYGON_TYPE:
            return <PolygonAndPolylineSvg data={shape} size={size} isDraggable={isDraggable} />
        case SOURCE_IMAGE_TYPE:
            return <SourceImageSvg levels={levels} levelsMode={levelsMode}  showOverlap={false} isDraggable={isDraggable} />
        default:
            console.debug('unknown type', shape.type)
    }

    return <g />
}

export function getBackgroundObjectByShape(shapeObject: Shape, newSize: SizeType): JSX.Element {
    const shapeWidth = shapeObject.width || 0
    const shapeHeight = shapeObject.height || 0

    const isResizeLayer = shapeObject.text_overflow === OVERFLOW_LAYERSIZE

    const w = isResizeLayer && newSize && newSize.width > shapeWidth ? newSize.width : shapeWidth
    const h = isResizeLayer && newSize && newSize.height > shapeHeight ? newSize.height : shapeHeight

    const dw = w - shapeWidth
    const dh = h - shapeHeight

    const width = shapeWidth
    const height = shapeHeight

    const bgcolor = shapeObject.gradient_id && shapeObject.gradient ? GradientFillUrl(shapeObject.gradient_id) : (shapeObject.text_background_color || 'transparent')
    const fillOpacity = shapeObject.gradient_id && shapeObject.gradient && shapeObject.gradient.opacity ? shapeObject.gradient.opacity / 100 : 1
    const isShadow = shapeObject.shadow_color && shapeObject.shadow_sigma
    const filter = isShadow ? `url(#shadow-${shapeObject.index})` : ''
    const cornerRadius = shapeObject.corner_radius ?? null;

    const horizontalTextAlign = shapeObject.text_align ? shapeObject.text_align : TEXT_HORIZONTAL_ALIGN_CENTER
    const verticalTextAlign = shapeObject.text_valign ? shapeObject.text_valign : TEXT_VERTICAL_ALIGN_MIDDLE

    const transX = dw > 0 ? .5*(horizontalTextAlign + 1) * dw : 0
    const transY = dh > 0 ? .5*(verticalTextAlign + 1) * dh : 0

    switch (shapeObject.text_background_type) {
        case CIRCLE_TYPE:
            return <circle r={width / 2} fill={bgcolor} fillOpacity={fillOpacity} strokeWidth={shapeObject.stroke_width} stroke={shapeObject.stroke_color} filter={filter} />
        case ELLIPSE_TYPE:
            return <ellipse rx={width / 2} ry={height / 2} fill={bgcolor} fillOpacity={fillOpacity} strokeWidth={shapeObject.stroke_width} stroke={shapeObject.stroke_color} filter={filter} />
        case RECTANGLE_TYPE:
            return <rect
                transform={`translate(${-.5*shapeWidth - transX}, ${-.5*shapeHeight - transY})`}
                width={dw > 0 ? w : shapeWidth}
                height={dh > 0 ? h : shapeHeight}
                fill={bgcolor}
                fillOpacity={fillOpacity}
                strokeWidth={shapeObject.stroke_width}
                stroke={shapeObject.stroke_color}
                filter={filter}
                strokeLinejoin={shapeObject.line_join && LINE_JOIN_CONSTS[shapeObject.line_join] ? LINE_JOIN_CONSTS[shapeObject.line_join] : DEFAULT_LINE_JOIN}
                strokeLinecap={shapeObject.line_cap && LINE_CAP_CONSTS[shapeObject.line_cap] ? LINE_CAP_CONSTS[shapeObject.line_cap] : DEFAULT_LINE_CAP}
                rx={cornerRadius ? cornerRadius : undefined}
                ry={cornerRadius ? cornerRadius : undefined}
            />
        case IMAGE_TYPE:
            return shapeObject.imageBlob ? <image
                id={`${shapeObject.index}-image`}
                width={width}
                height={height}
                transform={`translate(-${width / 2},-${height / 2})`}
                xlinkHref={shapeObject.imageBlob}
                filter={filter}
            /> : <g />
        case NONE_TYPE:
            return (shapeObject.stroke_color && shapeObject.stroke_width) ? <rect
                transform={`translate(-${width / 2},-${height / 2})`}
                width={width}
                height={height}
                fill={'transparent'}
                fillOpacity={fillOpacity}
                strokeWidth={shapeObject.stroke_width}
                stroke={shapeObject.stroke_color}
                filter={filter}
            /> : <g />
        default:
        case RECTANGLE_EACH_LINE_TYPE:
            return <g />
    }
}

export type WordsByLines = {
    words: readonly string[]
    width: number
}

export type AdaptiveFontSizeAndStyle = {
    fontSize: number
    lineHeight: number
    isOverflow: boolean
    updatedStyle: CSSProperties
    wordsByLines: WordsByLines[]
    wordsWithComputedWidth: WordLengthType[]
}

export function getTrimmedContent(shape) {
    const isVertical = shape.text_orientation === TEXT_ORIENTATION_VERTICAL
    const content = shape.type === TEXT_WITH_ELEMENTS_TYPE ? shape.text_content_replaced : (shape.text_content ? shape.text_content : '')

    let trimmedContent = typeof content === "string" ? content.trim() : JSON.stringify(content)
    const isMarkup = hasPangoMarkup(trimmedContent)

    if (isVertical) {
        trimmedContent = isMarkup ? splitPangoChars(trimmedContent, "\n") : trimmedContent.split('').join("\n")
    }

    //do letter case transforms (pango markup: only the text, not the tags):
    if (isMarkup && shape.letter_case && trimmedContent) {
        trimmedContent = mapPangoChars(trimmedContent, (char, prevChar, index) => {
            switch (shape.letter_case) {
                case LETTER_CASE_TO_UPPER:
                    return char.toUpperCase()
                case LETTER_CASE_TO_LOWER:
                    return char.toLowerCase()
                case LETTER_CASE_FIRST_LETTER_TO_UPPER:
                    return index === 0 ? char.toUpperCase() : char
                case LETTER_CASE_FIRST_LETTER_TO_LOWER:
                    return index === 0 ? char.toLowerCase() : char
                case LETTER_CASE_WORDS_FIRST_TO_UPPER:
                    return prevChar === '' || prevChar === ' ' ? char.toUpperCase() : char
                default:
                    return char
            }
        })
    } else if (shape.letter_case && trimmedContent && trimmedContent.length > 0) {
        switch (shape.letter_case) {
            case LETTER_CASE_TO_UPPER:
                trimmedContent = trimmedContent.toUpperCase()
                break
            case LETTER_CASE_TO_LOWER:
                trimmedContent = trimmedContent.toLowerCase()
                break
            case LETTER_CASE_FIRST_LETTER_TO_UPPER:
                trimmedContent = trimmedContent.charAt(0).toUpperCase() + trimmedContent.slice(1);
                break
            case LETTER_CASE_FIRST_LETTER_TO_LOWER:
                trimmedContent = trimmedContent.charAt(0).toLowerCase() + trimmedContent.slice(1);
                break
            case LETTER_CASE_WORDS_FIRST_TO_UPPER:
                const arr = trimmedContent.split(" ");
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                }
                trimmedContent = arr.join(" ");
                break
        }
    }

    return trimmedContent
}

export function getAdaptiveFontSize(shape: ShapeType, width: number, height: number, setRealSize: Function): AdaptiveFontSizeAndStyle {
    const textPadding = shape.text_padding ? shape.text_padding : 0
    const halfStrokeWidth = shape.stroke_width ? .5 * shape.stroke_width : 0
    const overflowRules = shape.text_overflow ? shape.text_overflow : OVERFLOW_KEEP_AS_IS

    const shapeWidthMinusPadding = width - 2 * textPadding - halfStrokeWidth
    const shapeHeightMinusPadding = height - 2 * textPadding - halfStrokeWidth
    // backend (image-composer getLinesForShape) wraps lines into width minus padding and the whole stroke width
    const shapeWrapWidth = width - 2 * textPadding - (shape.stroke_width || 0)

    const style: CSSProperties = {
        fontWeight: DEFAULT_FONT_WEIGHT,
        fontSize: shape.text_fontsize + "px",
        fontFamily: `"${shape.text_fontfamily}","Unicode-BMP-Fallback-SIL"`,
        letterSpacing: shape.letter_spacing ? `${shape.letter_spacing}px` : undefined,
        strokeWidth: shape.text_stroke_width || 0,
        stroke: shape.text_stroke_color || undefined,
        strokeLinejoin: 'round',
        width: shapeWidthMinusPadding + 'px',
        textDecorationColor: shape.text_decoration_color || shape.text_color,
    }

    let newFontSize = shape.text_fontsize
    let wordsWithComputedWidth: WordLengthType[]
    let wordsByLines: WordsByLines[]
    let isOverflow = false
    let spaceSize: {
        w: number
        h: number
    }

    const content = getTrimmedContent(shape)
    const replacedBreaks = content ? content.split(manualBreakLine).join(" <BR>") : ''
    const lines = typeof shape.lines === 'string' && isJson(shape.lines) ? JSON.parse(shape.lines) : shape.lines

    //check fontSize, if overflow and change font, rewrite
    let i = 0
    do {
        const adaptedStyle = {
            ...style,
            fontSize: `${newFontSize}px`
        }

        spaceSize = getStringWidthAndHeight('\xA0', adaptedStyle);  //get space width and line height

        //pango markup: do not split inside the tags (<span foreground="red">), every word is valid markup on its own
        const words = hasPangoMarkup(replacedBreaks) ? splitPangoWords(replacedBreaks) : replacedBreaks.split(/\s+/)
        const newWordsWithComputedWidth = words.map(function (word) {
            const { w, h } = getStringWidthAndHeight(word.replace("<BR>", ""), adaptedStyle)
            return { word: word, width: w, height: h };
        })

        if (newWordsWithComputedWidth) {
            wordsByLines = newWordsWithComputedWidth.reduce(function (result, _ref2) {
                const i = result.length - 1
                let currentLine = result[i]
                const lineType = Array.isArray(lines) && lines[i] ? (lines[i] ?? null) : null
                const replaced = _ref2.word.replace("<BR>", "")

                const maxWidth = lineType && lineType.x1 && lineType.x2 ? (lineType.x2 - lineType.x1) : shapeWrapWidth

                // measure the whole candidate line (words are rendered joined by spaces) - same as backend imagick wrapping
                const candidateWidth = currentLine && !_ref2.word.includes("<BR>")
                    ? getStringWidthAndHeight([...currentLine.words, replaced].join(' '), adaptedStyle)?.w ?? (currentLine.width + spaceSize.w + _ref2.width)
                    : 0

                if (!_ref2.word.includes("<BR>") && currentLine && (width === null || candidateWidth < maxWidth)) {  // Word can be added to an existing line
                    currentLine.words.push(replaced);
                    currentLine.width = candidateWidth;
                } else {    // Add first word to line or word is too long to scaleToFit on existing line
                    result.push({ words: [replaced], width: _ref2.width });
                }

                return result;
            }, []);

            const totalTextHeight = wordsByLines.length * spaceSize.h

            isOverflow = (totalTextHeight > shapeHeightMinusPadding)

            let maxLineWidth = 0
            if (wordsByLines && Array.isArray(wordsByLines)) {
                wordsByLines.forEach(wbl => {
                    if (wbl.width > maxLineWidth) {
                        maxLineWidth = wbl.width
                    }
                    if (wbl.width > shapeWidthMinusPadding) {
                        isOverflow = true
                    }
                })
            }

            if (typeof setRealSize === 'function' && shape.text_overflow === OVERFLOW_LAYERSIZE) {
                setRealSize({
                    width: maxLineWidth,
                    height: totalTextHeight,
                })
            }

            wordsWithComputedWidth = newWordsWithComputedWidth
        }
        i++;

        if (isOverflow && overflowRules === OVERFLOW_FONTSIZE) {
            newFontSize = round(newFontSize - newFontSize * .12)
        }

        if (i > 19) {
            console.debug(`!!! adaptive font size, iteration ${i} of max 20`)
        }
    } while (isOverflow && shape.text_overflow === OVERFLOW_FONTSIZE && i <= 20)   //resize font

    const finalFontSize = shape.text_overflow === OVERFLOW_FONTSIZE ? newFontSize : shape.text_fontsize
    const updatedStyle: CSSProperties = { ...style, fontSize: `${finalFontSize}px`, pointerEvents: 'auto' }

    return {
        fontSize: finalFontSize,
        isOverflow: isOverflow,
        lineHeight: spaceSize?.h ? spaceSize.h : newFontSize,
        wordsWithComputedWidth: wordsWithComputedWidth,
        wordsByLines: wordsByLines,
        updatedStyle: updatedStyle,
    }
}


 /**
  * see also keepSizeRatioAndMinSize in image-preview
  *
  * @param shape: ShapeType
  * @param realSize: SizeType
  * @param updateShapeFunction: Function
  *
  * @return void
  */
export function checkOverflowAndResizeShape(shape: ShapeType, realSize: SizeType, updateShapeFunction: Function): void {
    const shapeSize = getShapeSize(shape)
    const templateSize = getTemplateSize()

    const textPadding = shape.text_padding ? shape.text_padding : 0
    const halfStrokeWidth = shape.stroke_width ? .5 * shape.stroke_width : 0

    const maxWidth = templateSize.width - 2 * textPadding - halfStrokeWidth
    const maxHeight = templateSize.height - 2 * textPadding - halfStrokeWidth

    const shapeWidthWithoutPadding = shapeSize.width - 2 * textPadding - halfStrokeWidth
    const shapeHeightWithoutPadding = shapeSize.height - 2 * textPadding - halfStrokeWidth

    const realWidthPlusPadding = realSize ? realSize.width + 2 * textPadding + halfStrokeWidth : shape.width
    const realHeightPlusPadding = realSize ? realSize.height + 2 * textPadding + halfStrokeWidth : shape.height

    const isOverFlowX = realSize && realSize.width > shapeWidthWithoutPadding
    const isOverFlowY = realSize && realSize.height > shapeHeightWithoutPadding

    const isBehindCornerX = !realSize ? null : (((shape.x + .5 * realWidthPlusPadding) > templateSize.width) ? 1 : ((shape.x - .5 * realWidthPlusPadding) < 0) ? -1 : false)
    const isBehindCornerY = !realSize ? null : (((shape.y + .5 * realHeightPlusPadding) > templateSize.height) ? 1 : ((shape.y - .5 * realHeightPlusPadding) < 0) ? -1 : false)

    //console.debug(`is behind? ${shape.type} ${isBehindCornerX} ${isBehindCornerY}`)   //nespousti se pro rating?

    const isTextWrap = shape.text_wrap
    const isAspectRatio = shape.is_aspect_size_ratio || shouldAspectRatio(shape.type)

    if (typeof updateShapeFunction === 'function' && (isOverFlowX || isOverFlowY || isBehindCornerX || isBehindCornerY)) {
        if (isOverFlowX && !isTextWrap) {   //podminky pro prepnuti text_wrap napr. rozmery 2x vetsi nez rozmery vrstvy apod
            console.debug(`no text wrap, setting wrap on`)
            updateShapeFunction({
                ...shape,
                text_wrap: 1
            })
        } else if (realSize && (shape.type === RATING_TYPE || isAutoGrowOn())) {   //rating always has to fit
            let w = max(realSize.width, shapeSize.width)    //pro rating nesmi byt plus textPadding!!!!    width plus textPadding pro jine nez rating???
            let h = max(realSize.height, shapeSize.height)

            //console.debug(`shape size ${shapeSize.width}x${shapeSize.height} real ${realWidthPlusPadding}x${realHeightPlusPadding}`)

            if (w > maxWidth) {
                w = maxWidth
            }

            if (h > maxHeight) {
                h = maxHeight
            }

            if (isAspectRatio) {
                const r = shapeSize.width / shapeSize.height
                if (shapeWidthWithoutPadding < shapeHeightWithoutPadding) {
                    h = w / r   //keep width, calc height
                } else {
                    w = h * r   //keep height, calc width
                }
            }

            const newPosition = getAnchoredShapePosition(shape, shapeSize, { width: w, height: h }, { width: realWidthPlusPadding, height: realHeightPlusPadding })

            const newWidth = round(w)
            const newHeight = round(h)

            const newX = round(newPosition.x)
            const newY = round(newPosition.y)

            //console.debug(`${shape.type} delta position: ${deltaX}, ${deltaY}, size from ${shapeSize.width}x${shapeSize.height} --> ${w}x${h}`)

            const isUnchanged = newWidth === round(shape.width) && newHeight === round(shape.height) &&
                newX === round(shape.x) && newY === round(shape.y)

            if (!isUnchanged) {   //guard against re-dispatching the same size and looping forever (see checkAndUpdateFontSize)
                let newFontSize = shape.text_fontsize
                let newTextPadding = shape.text_padding

                if (shape.type === RATING_TYPE) {
                    newFontSize = getRatingShapeFontSize(shape as RatingShape, newWidth, newHeight)
                    const c = newFontSize / shape.text_fontsize
                    newTextPadding = shape.text_padding ? round(c * shape.text_padding) : shape.text_padding
                }

                updateShapeFunction({
                    ...shape,
                    width: newWidth,
                    height: newHeight,
                    text_fontsize: newFontSize,
                    text_padding: newTextPadding,
                    x: newX,
                    y: newY,
                })
            }
        }
    }
}

/**
 * position (center) shift of a shape whose size changes by dw x dh, so that the edges given by text_align / text_valign
 * stay in place (left/top for start, right/bottom for end, center for middle), respecting the shape rotation
 */
export function getAlignAnchorOffset(shape: ShapeType, dw: number, dh: number): { x: number, y: number } {
    const horizontalTextAlign = shape.text_align ? Number(shape.text_align) : TEXT_HORIZONTAL_ALIGN_CENTER
    const verticalTextAlign = shape.text_valign ? Number(shape.text_valign) : TEXT_VERTICAL_ALIGN_MIDDLE
    const dx = -.5 * horizontalTextAlign * dw
    const dy = -.5 * verticalTextAlign * dh
    const a = (shape.angle || 0) * PI / 180

    return {
        x: dx * cos(a) - dy * sin(a),
        y: dx * sin(a) + dy * cos(a),
    }
}

/**
 * new center of a shape resized from oldSize to newSize: the edges given by the text align stay in place (rating grows
 * to the right and down, it has no text align), but the shape is moved back inside the template if it would overflow it
 *
 * @param extentSize: the size that has to fit into the template (e.g. the text plus padding), newSize by default
 */
export function getAnchoredShapePosition(shape: ShapeType, oldSize: SizeType, newSize: SizeType, extentSize: SizeType = newSize): { x: number, y: number } {
    const templateSize = getTemplateSize()

    const dw = newSize.width - oldSize.width
    const dh = newSize.height - oldSize.height

    const anchorOffset = shape.type === RATING_TYPE ? { x: .5 * max(dw, 0), y: .5 * max(dh, 0) } : getAlignAnchorOffset(shape, dw, dh)

    let x = shape.x + anchorOffset.x
    let y = shape.y + anchorOffset.y

    if (x - .5 * extentSize.width < 0) {
        x = .5 * newSize.width
    } else if (x + .5 * extentSize.width > templateSize.width) {
        x = templateSize.width - .5 * newSize.width
    }

    if (y - .5 * extentSize.height < 0) {
        y = .5 * newSize.height
    } else if (y + .5 * extentSize.height > templateSize.height) {
        y = templateSize.height - .5 * newSize.height
    }

    return { x, y }
}

export function isAutoGrowOn(): boolean {
    const guides: GuidesType = (store.getState() as any).guides
    return guides?.isAutoGrowOn !== false
}

export function getTextPadding(fontSize: number, textOverflow: number): number
{
    return textOverflow === OVERFLOW_FONTSIZE ? 0 : .5*fontSize
}

export function renderClipMaskShape(maskObject: ClipMaskObject, isPreviewStyle: boolean, isInvert?: boolean, translateX?: number, translateY?: number, ref?: React.LegacyRef<any>, isTransparent?: boolean, updatePoints?: Function, newPointAngle?: number): React.JSX.Element {
    const style: CSSProperties = {
        pointerEvents: isPreviewStyle ? 'auto' : 'none',
        fontSize: maskObject.fontSize ? `${maskObject.fontSize}px` : undefined,
        fontFamily: maskObject.fontFamily ? maskObject.fontFamily : undefined,
    }

    const fillColor = isInvert ? (isPreviewStyle ? '#a3a3a3' : 'black') : (isTransparent ? 'none' : (isPreviewStyle ? '#ffffffeb' : '#000'))
    const strokeColor = (isInvert && isPreviewStyle) ? '#3a3a3a' : (isPreviewStyle ? '#cccccc' : undefined)
    const strokeWidth = isPreviewStyle ? 2 : undefined
    const dashArray = isPreviewStyle ? '5 1' : (isTransparent ? '4 1' : undefined)

    const addX = translateX || 0
    const addY = translateY || 0

    switch (maskObject.type) {
        case 'rect':
            return <rect
                width={maskObject.width}
                height={maskObject.height}
                fill={fillColor}
                strokeDasharray={dashArray}
                strokeWidth={strokeWidth}
                stroke={strokeColor}
                style={style}
                ref={isPreviewStyle ? ref : undefined}
                transform={`translate(${maskObject.x - maskObject.width / 2 + addX},${maskObject.y - maskObject.height / 2 + addY}) rotate(${maskObject.angle || 0}, ${.5 * maskObject.width}, ${.5 * maskObject.height})`}
            />
        case 'circle':
            return <circle
                cx={maskObject.x + addX}
                cy={maskObject.y + addY}
                r={maskObject.width / 2}
                fill={fillColor}
                strokeDasharray={dashArray}
                strokeWidth={strokeWidth}
                stroke={strokeColor}
                style={style}
                ref={isPreviewStyle ? ref : undefined}
            />
        case 'ellipse':
            return <ellipse
                cx={maskObject.x + addX}
                cy={maskObject.y + addY}
                rx={maskObject.width / 2}
                ry={maskObject.height / 2}
                fill={fillColor}
                strokeDasharray={dashArray}
                strokeWidth={strokeWidth}
                stroke={strokeColor}
                style={style}
                ref={isPreviewStyle ? ref : undefined}
            />
        case 'text':
            return <text
                dominantBaseline={"central"}
                textAnchor={"middle"}
                className='unselectable'
                style={style}
                fill={fillColor}
                ref={isPreviewStyle ? ref : undefined}
                transform={`translate(${maskObject.x + addX},${maskObject.y + addY}) rotate(${maskObject.angle || 0}, ${0 * .5 * maskObject.width}, ${0 * .5 * maskObject.height})`}
            >{maskObject.textContent}</text>
        case 'bezier':
        case 'polygon':
            return <React.Fragment>
                {maskObject.points &&
                    <MoveablePoints
                        maskObject={maskObject}
                        updatePoints={updatePoints}
                        ref={isPreviewStyle ? ref : undefined}
                        fillColor={fillColor}
                        strokeColor={strokeColor}
                        strokeWidth={strokeWidth}
                        dashArray={dashArray}
                        newPointAngle={newPointAngle}
                        transformX={addX}
                        transformY={addY}
                    />
                }
            </React.Fragment>
        default:
            return <g />
    }
}

const SVG_RESCALE_DEBOUNCE_MS = 400
const svgRescaleDebouncers = new Map<string | number, (task: () => void) => void>()

// getUpdatedShapeOrFontSize runs on every drag tick (see keepSizeRatioAndMinSize in image-preview.tsx),
// so the actual svgRescale call is debounced per shape to avoid firing on every mousemove.
function scheduleSvgRescale(shapeKey: string | number, task: () => void): void {
    let debounced = svgRescaleDebouncers.get(shapeKey)
    if (!debounced) {
        debounced = debounce((fn: () => void) => fn(), SVG_RESCALE_DEBOUNCE_MS)
        svgRescaleDebouncers.set(shapeKey, debounced)
    }
    debounced(task)
}

export const MIN_FONT_SIZE = 4
export function getUpdatedShapeOrFontSize(shape: Shape, deltaPositions: DeltaPositionsType, keepSizeRatio?: number): Shape {
    const PRECISION = 50

    const templateSize = getTemplateSize()
    const isPointType = isPointShapeType(shape.type)

    const alpha = (shape.angle ?? 0)
    const a = alpha * PI / 180

    const shapeSize = getShapeSize(shape)

    let effectiveDeltaPositions = { ...deltaPositions }

    // Min size enforcement
    if (shapeSize.width + (effectiveDeltaPositions.x2 - effectiveDeltaPositions.x1) < 10) {
        effectiveDeltaPositions.x1 = -5
        effectiveDeltaPositions.x2 = 5
    }
    if (shapeSize.height + (effectiveDeltaPositions.y2 - effectiveDeltaPositions.y1) < 10) {
        effectiveDeltaPositions.y1 = -5
        effectiveDeltaPositions.y2 = 5
    }

    let deltaWidth = effectiveDeltaPositions.x2 - effectiveDeltaPositions.x1
    let deltaHeight = effectiveDeltaPositions.y2 - effectiveDeltaPositions.y1

    let newWidth = round(abs(shapeSize.width + deltaWidth))
    let newHeight = round(abs(shapeSize.height + deltaHeight))

    //regulate to max size?
    if (templateSize) {
        let maxWidth = templateSize.width
        let maxHeight = templateSize.height

        if ([BITMAP_TYPE, BADGE_TYPE, CUSTOM_SET_TYPE, IMAGE_FROM_ELEMENTS_TYPE].includes(shape.type)) {
            maxWidth = 4 * maxWidth
            maxHeight = 4 * maxHeight
        }

        if (newWidth >= maxWidth) {
            newWidth = maxWidth
        }
        if (newHeight >= maxHeight) {
            newHeight = maxHeight
        }
    }

    let newFontSize = shape.text_fontsize

    if (shape.type === RATING_TYPE && (deltaWidth || deltaHeight)) {
        //do not change size unless deltaWidth || deltaHeight
        //keep width and height in given ratio
        newFontSize = getRatingShapeFontSize(shape as RatingShape, newWidth, newHeight)

        const ratingSize = getRatingShapeSize(newFontSize, shape.text_padding, shape.stroke_width)

        newWidth = ratingSize.width
        newHeight = ratingSize.height

        deltaWidth = newWidth - shapeSize.width
        deltaHeight = newHeight - shapeSize.height
    }

    //const newSize = ['left', 'right', 'top', 'bottom'].includes(type) ? calcBackgroundSize(updatedShape, updatedShape.text_content) : { width: shape.width, height: shape.height }
        //console.debug(`type: ${type} ${shape.type} we have new shape size, changing`, newSize)
            //width: newSize.width,
    //height: newSize.height,

    // Aspect ratio enforcement
    if (keepSizeRatio && deltaPositions.type !== 'move' && deltaPositions.type !== 'rotate' && deltaPositions.type) {
        const newSizeRatio = newHeight !== 0 ? newWidth / newHeight : keepSizeRatio
        const oldSizeRatioRounded = round(PRECISION * keepSizeRatio) / PRECISION
        const newSizeRatioRounded = round(PRECISION * newSizeRatio) / PRECISION

        if (newSizeRatioRounded !== oldSizeRatioRounded) {
            const calculatedDw = keepSizeRatio * newHeight - shapeSize.width
            const calculatedDh = newWidth / keepSizeRatio - shapeSize.height
            const c = deltaWidth !== 0 ? calculatedDw / deltaWidth : 1
            const d = deltaHeight !== 0 ? calculatedDh / deltaHeight : 1

            const x1 = round(c * deltaPositions.x1)
            const x2 = round(c * deltaPositions.x2)
            const y1 = round(d * deltaPositions.y1)
            const y2 = round(d * deltaPositions.y2)

            switch (deltaPositions.type) {
                case 'top':
                case 'bottom':
                    effectiveDeltaPositions.x1 = x1
                    effectiveDeltaPositions.x2 = x2
                    break
                case 'left':
                case 'right':
                    effectiveDeltaPositions.y1 = y1
                    effectiveDeltaPositions.y2 = y2
                    break
                default:
                    if (calculatedDw) {
                        effectiveDeltaPositions.x1 = round(.5 * (deltaPositions.x1 + deltaPositions.x2 - calculatedDw))
                        effectiveDeltaPositions.x2 = round(.5 * (deltaPositions.x1 + deltaPositions.x2 + calculatedDw))
                    } else if (calculatedDh) {
                        effectiveDeltaPositions.y1 = round(.5 * (deltaPositions.y1 + deltaPositions.y2 - calculatedDh))
                        effectiveDeltaPositions.y2 = round(.5 * (deltaPositions.y1 + deltaPositions.y2 + calculatedDh))
                    }
                    break
            }

            deltaWidth = effectiveDeltaPositions.x2 - effectiveDeltaPositions.x1
            deltaHeight = effectiveDeltaPositions.y2 - effectiveDeltaPositions.y1

            newWidth = abs(round(shapeSize.width + deltaWidth))
            newHeight = abs(round(shapeSize.height + deltaHeight))
        }
    }

    const scaleX = shapeSize.width > 0 ? newWidth / shapeSize.width : 1
    const scaleY = shapeSize.height > 0 ? newHeight / shapeSize.height : 1

    const deltaX = round(effectiveDeltaPositions.x1 + .5 * deltaWidth)
    const deltaY = round(effectiveDeltaPositions.y1 + .5 * deltaHeight)

    const c = cos(a)
    const s = sin(a)

    const newX = round(shape.x + deltaX * c - deltaY * s)
    const newY = round(shape.y + deltaY * c + deltaX * s)

    const updatedMaskObjects = recalcClipMaskSizeAndPositions(effectiveDeltaPositions, shapeSize.width, shapeSize.height, shape.clip_mask, true)
    const newClipmask = shape.clip_mask ? JSON.stringify(updatedMaskObjects) : shape.clip_mask

    const scale = (scaleX + scaleY) / 2
    const scaledFontSize = shape.text_fontsize && (shape.text_fontsize * scale) > MIN_FONT_SIZE ? round(shape.text_fontsize * scale) : shape.text_fontsize

    newFontSize = shape.type === RATING_TYPE ? scaledFontSize : shape.text_fontsize

    //change font size if it is corner handle:
    if (effectiveDeltaPositions.type && shape.text_fontsize && RESIZE_TYPES_TO_CHANGE_FONTSIZE.includes(effectiveDeltaPositions.type)) {
        newFontSize = scaledFontSize
    }

    const updatedShape = {
        ...shape,
        width: newWidth,
        height: newHeight,
        clip_mask: newClipmask,
        text_fontsize: newFontSize,
        x: newX,
        y: newY,
    }

    switch (shape.type) {
        case BADGE_TYPE:
            //if there were changes, re-save as bitmap type:
            if (!shape.is_aspect_size_ratio && (shape.width !== newWidth || shape.height !== newHeight)) {
                scheduleSvgRescale(shape.index, () => {
                    try {
                        const request = new XMLHttpRequest()

                        request.open("GET", shape.imageBlob)
                        request.setRequestHeader("Content-Type", "image/svg+xml")
                        request.addEventListener("load", (event) => {
                            const eventTarget: any = event.target
                            const svg = eventTarget.responseText

                            svgRescale(svg, round(newWidth), round(newHeight))
                                .then((response: AxiosResponse<any>) => {
                                    if (response.data && response.data.result) {

                                        const resizedShape = {
                                            ...shape,
                                            type: BITMAP_TYPE,
                                            set_id: null,
                                            set_file_id: null,
                                            width: newWidth,
                                            height: newHeight,
                                            clip_mask: newClipmask,
                                            x: newX,
                                            y: newY,
                                            imageBlob: "data:image/svg+xml," + encodeURIComponent(response.data.result),
                                        }

                                        return resizedShape
                                    }
                                })
                                .catch(e => {
                                    console.debug('svg rescale error', e)
                                })
                        });

                        request.send();
                    } catch (e) {
                        console.debug('cannot rescale svg', e)
                    }
                })
            }
            return updatedShape
        case BITMAP_TYPE:
            if (shape.imageBlob && !shape.is_aspect_size_ratio && shape.imageBlob.slice(0, 150).includes('svg+xml')) {
                scheduleSvgRescale(shape.index, () => {
                    svgRescale(shape.imageBlob, newWidth, newHeight)
                        .then((response: AxiosResponse<any>) => {
                            if (response.data && response.data.result) {
                                return {
                                    ...updatedShape,
                                    imageBlob: "data:image/svg+xml," + encodeURIComponent(response.data.result),
                                    //imageBlob: "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(response.data.result)))
                                }
                            }
                        })
                        .catch(e => {
                            console.debug('error', e)
                        })
                })
            }
            return updatedShape
        case BRUSH_TYPE:
            return {
                ...updatedShape,
                brush_strokes: scaleBrushStrokes(shape.brush_strokes, scaleX, scaleY),
            }
        default:
            if (isPointType) {
                return {
                    ...updatedShape,
                    points: typeof shape.points !== 'undefined' ? scalePoints(shape.points, scaleX, scaleY) : undefined,
                }
            } else {
                return updatedShape
            }
    }
}
